export default __webpack_public_path__ + "static/media/Upload.75b9ac34.svg";